export default class BlockPromoImage extends Core.BlockComponent {
  constructor(el, context) {
    super(el, context);
    this.image = el.querySelector('img');
  }

  get blockHeight() {
    return this.image
      ? `${this.image.naturalHeight}px`
      : '300px'; /* placeholder value for SVG */
  }
}
